// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { createSelector } from '@ngrx/store';
import { accessManagementSelector } from '../index';
import {
  getGroupDetailsLoadable,
  getGroupDetails,
  getSelectedUsers,
  getGroupUserSelections,
  getUserToEdit
} from './group-details.reducers';

export const selectGroupDetails = createSelector(accessManagementSelector, state => state.groupDetails);

export const selectGroupDetailsLoadable = (groupId: string) =>
  createSelector(selectGroupDetails, getGroupDetailsLoadable(groupId));

export const selectGroupDetail = (id: string) => createSelector(selectGroupDetails, getGroupDetails(id));

export const selectSelectedUsers = (id: string) => createSelector(selectGroupDetails, getSelectedUsers(id));

export const selectGroupUserSelections = (id: string) => createSelector(selectGroupDetails, getGroupUserSelections(id));

export const selectUserToEdit = (id: string) => createSelector(selectGroupDetails, getUserToEdit(id));



// WEBPACK FOOTER //
// ./src/app/access-management/state/group-details/group-details.selectors.ts